import LoadingBlock from "../../components/LoadingBlock";
import { useApi } from "../../hooks/useApi";
import { mySubscription } from "../../api/subscriptionService";
import { formatDate } from "../../utils/formatters";

const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

const STATUS_BADGE = {
  active: ["badge-success", "Active"],
  grace: ["badge-warning", "Payment overdue (grace)"],
  suspended: ["badge-danger", "Suspended"],
};

export default function SubscriptionPage() {
  const res = useApi(() => mySubscription());
  const d = res.data?.data;

  if (res.loading || !d) return <LoadingBlock rows={6} />;

  const sub = d.subscription;
  const [badgeClass, badgeLabel] = STATUS_BADGE[sub?.status] || ["badge-neutral", "None"];

  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">Subscription</h1>
          <div className="page-sub">Your firm's Smart CA plan — payments are arranged with the Smart CA team.</div>
        </div>
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-head"><div className="card-title">Plan</div></div>
          <div className="card-body">
            <Row label="Status">
              <span className="row gap-sm">
                {sub?.is_trial && <span className="badge badge-purple">Trial</span>}
                <span className={`badge ${badgeClass}`}>{badgeLabel}</span>
              </span>
            </Row>
            {sub && (
              <>
                <Row label="Paid seats">{sub.seats} (using {d.seat_usage})</Row>
                <Row label={sub.is_trial ? "Amount" : "Yearly amount"}>{sub.is_trial ? "Free trial" : inr(sub.yearly_amount)}</Row>
                <Row label="Current period">{formatDate(sub.period_start)} → {formatDate(sub.period_end)}</Row>
                {sub.grace_until && <Row label="Grace until">{formatDate(sub.grace_until)}</Row>}
              </>
            )}
            <div className="t-muted" style={{ fontSize: 12, marginTop: 10 }}>
              Seats cover your active employees plus admins beyond the first. Need more? Contact Devsoleil.
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-head"><div className="card-title">Storage</div></div>
          <div className="card-body">
            {d.storage && (
              <>
                <Row label="Pooled drive storage">{d.storage.used_gb} / {d.storage.quota_gb} GB</Row>
                <div style={{ background: "var(--ink-100, #e5e7eb)", borderRadius: 6, height: 8, overflow: "hidden", margin: "6px 0 10px" }}>
                  <div style={{
                    width: Math.min(100, (d.storage.used_gb / Math.max(d.storage.quota_gb, 0.01)) * 100) + "%",
                    background: d.storage.used_gb / Math.max(d.storage.quota_gb, 0.01) > 0.9 ? "var(--danger, #b91c1c)" : "var(--primary, #2563eb)",
                    height: "100%",
                  }} />
                </div>
                <div className="t-muted" style={{ fontSize: 12 }}>
                  Org drive and all client drives share this pool. Need more? Ask Smart CA for prepaid Extra Storage (per GB).
                </div>
              </>
            )}
          </div>
        </div>

        <div className="card">
          <div className="card-head"><div className="card-title">Active addons</div></div>
          <div className="card-body">
            {d.addons?.length ? d.addons.map((a) => (
              <Row key={a.id} label={a.name + (a.unit_label && a.pivot?.quantity ? ` (${a.pivot.quantity} ${a.unit_label})` : "")}>
                {inr(a.monthly_price)}/month{a.unit_label ? ` per ${a.unit_label}` : ""}
              </Row>
            )) : <div className="t-muted">No addons enabled. Ask Smart CA about realtime push notifications and extra storage.</div>}
          </div>
        </div>
      </div>
    </>
  );
}

function Row({ label, children }) {
  return (
    <div className="row" style={{ justifyContent: "space-between", marginBottom: 8 }}>
      <span className="t-muted">{label}</span>
      <span>{children}</span>
    </div>
  );
}
